module.exports = __webpack_public_path__ + "static/media/komponenty_led-matrix.4943d8ef.svg";